import React, { useEffect, useState } from "react";
import "./Sort_by_Modal.css";
import { Modal, Form, Offcanvas, Tab, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  BestSuited,
  CategoryType,
  getAllCategories,
  getAllDataSubCategory,
} from "../../../../features/master/masterSlice";

function Sort_by_Modal({
  selectedOptions,
  setSelectedOptions,
  selectedOptionsBest,
  setSelectedOptionsBest,
  selectedOption,
  setSelectedOption,
  ...props
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionChange = (event) => {
    const { value, checked } = event.target;
    const id = parseInt(value); // convert string to number

    if (checked) {
      setSelectedOptions([...selectedOptions, id]);
    } else {
      setSelectedOptions(selectedOptions.filter((item) => item !== id));
    }
  };

  // const [selectedOptionsBest, setSelectedOptionsBest] = useState([]);

  const handleOptionChangeBest = (event) => {
    const { value, checked } = event.target;
    const id = parseInt(value); // convert string to number

    if (checked) {
      setSelectedOptionsBest([...selectedOptionsBest, id]);
    } else {
      setSelectedOptionsBest(selectedOptionsBest.filter((item) => item !== id));
    }
  };
  const dispatch = useDispatch();
  const bestSuiteds = useSelector((state) => state.master.all_best_suited);

  const category_type = useSelector((state) => state.master.all_category_type);
  useEffect(() => {
    dispatch(BestSuited());
    dispatch(CategoryType());
  }, [dispatch]);

  const handleClear = () => {
    setSelectedOptionsBest("");
    setSelectedOptions("");
    props.onHide();
  };

  return (
    <>
      <section className="Sort_by_Modal modal-holder">
        {["end"].map((placement, idx) => (
          <Offcanvas
            show={show}
            onHide={handleClose}
            {...props}
            key={idx}
            placement={placement}
            name={placement}
            className="Use_Current_Location_offcanvas modal-holder Sort_by_Modal"
          >
            <Offcanvas.Body>
              <div>
                <div className="logo_holder">
                  <img
                    src="/assets/images/header/header_logo2.png"
                    className="logo_img"
                  />
                </div>
                <div className="heading_holder">
                  <h3>Filter By</h3>
                </div>
                <div className="sort_tab-holder">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="first"
                  >
                    <div className="row">
                      <div className="col-12">
                        <Nav variant="pills" className="d-flex gap-1 mb-3">
                          <Nav.Item>
                            <Nav.Link eventKey="first">Chicken Type</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="second">
                              Best Suited for
                            </Nav.Link>
                          </Nav.Item>
                          {/* <Nav.Item>
                            <Nav.Link eventKey="third">Pack Size</Nav.Link>
                          </Nav.Item> */}
                        </Nav>
                      </div>
                      <div className="col-12">
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <Form className="form-holder">
                              <Form.Group>
                                {category_type?.map((val) => (
                                  <div
                                    className="radio-btn-text-holder"
                                    key={val.id}
                                  >
                                    <p
                                      className={
                                        selectedOptions.includes(val.id)
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      {val?.name}
                                    </p>
                                    <Form.Check
                                      type="checkbox"
                                      name="sortOptions"
                                      value={val.id} // use id as value
                                      checked={selectedOptions.includes(val.id)}
                                      onChange={handleOptionChange}
                                    />
                                  </div>
                                ))}
                              </Form.Group>
                            </Form>
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <Form className="form-holder">
                              <Form.Group>
                                {bestSuiteds?.map((val) => (
                                  <div
                                    className="radio-btn-text-holder"
                                    key={val.id}
                                  >
                                    <p
                                      className={
                                        selectedOptionsBest?.includes(val?.id)
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      {val?.name}
                                    </p>
                                    <Form.Check
                                      type="checkbox"
                                      name="sortOptions"
                                      value={val.id} // use id as value
                                      checked={selectedOptionsBest?.includes(
                                        val.id
                                      )}
                                      onChange={handleOptionChangeBest}
                                    />
                                  </div>
                                ))}

                                {/* <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "DESC" ? "active" : ""
                                    }
                                  >
                                    Price - High to Low
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="DESC"
                                    checked={selectedOption === "DESC"}
                                    onChange={handleOptionChange}
                                  />
                                </div>

                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "ASC" ? "active" : ""
                                    }
                                  >
                                    Price - Low to High
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="ASC"
                                    checked={selectedOption === "ASC"}
                                    onChange={handleOptionChange}
                                  />
                                </div>

                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "DESC" ? "active" : ""
                                    }
                                  >
                                    Discount - High to Low
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="DESC"
                                    checked={selectedOption === "DESC"}
                                    onChange={handleOptionChange}
                                  />
                                </div> */}
                              </Form.Group>
                            </Form>
                          </Tab.Pane>
                          {/* <Tab.Pane eventKey="third">
                            <Form className="form-holder">
                              <Form.Group>
                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "" ? "active" : ""
                                    }
                                  >
                                    Default
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value=""
                                    checked={selectedOption === ""}
                                    onChange={handleOptionChange}
                                  />
                                </div>

                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "DESC" ? "active" : ""
                                    }
                                  >
                                    Price - High to Low
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="DESC"
                                    checked={selectedOption === "DESC"}
                                    onChange={handleOptionChange}
                                  />
                                </div>

                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "ASC" ? "active" : ""
                                    }
                                  >
                                    Price - Low to High
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="ASC"
                                    checked={selectedOption === "ASC"}
                                    onChange={handleOptionChange}
                                  />
                                </div>

                                <div className="radio-btn-text-holder">
                                  <p
                                    className={
                                      selectedOption === "DESC" ? "active" : ""
                                    }
                                  >
                                    Discount - High to Low
                                  </p>
                                  <Form.Check
                                    type="checkbox"
                                    name="sortOptions"
                                    value="DESC"
                                    checked={selectedOption === "DESC"}
                                    onChange={handleOptionChange}
                                  />
                                </div>
                              </Form.Group>
                            </Form>
                          </Tab.Pane> */}
                        </Tab.Content>
                      </div>
                    </div>
                  </Tab.Container>
                </div>
              </div>
            </Offcanvas.Body>

            <div className="offcanvas_footer_holder ms-0 gap-2">
              <p className="clear_all_text" onClick={handleClear}>
                Clear Filters
              </p>
            </div>
            <div className="overlay_holder"></div>
          </Offcanvas>
        ))}

        {/* <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Sort_by_Modal modal-holder"
        >
          <Modal.Header className="common_modal_header">
            <Modal.Title>Sort by</Modal.Title>
            <div className="right_side_close_modal_btn">
              <img src="/assets/images/cart/close.png" className="close_modal_img" onClick={() => { props?.onHide() }} />
            </div>
          </Modal.Header>
          <Modal.Body>
            <Form className="form-holder">
              <Form.Group>
                <div className="radio-btn-text-holder">
                  <p className={selectedOption === "" ? "active" : ""}>
                    Default
                  </p>
                  <Form.Check
                    type="checkbox"
                    name="sortOptions"
                    value=""
                    checked={selectedOption === ""}
                    onChange={handleOptionChange}
                  />
                </div>

                <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "DESC" ? "active" : ""
                    }
                  >
                    Price - High to Low
                  </p>
                  <Form.Check
                    type="checkbox"
                    name="sortOptions"
                    value="DESC"
                    checked={selectedOption === "DESC"}
                    onChange={handleOptionChange}
                  />
                </div>

                <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "ASC" ? "active" : ""
                    }
                  >
                    Price - Low to High
                  </p>
                  <Form.Check
                    type="checkbox"
                    name="sortOptions"
                    value="ASC"
                    checked={selectedOption === "ASC"}
                    onChange={handleOptionChange}
                  />
                </div>

                <div className="radio-btn-text-holder">
                  <p
                    className={
                      selectedOption === "DESC" ? "active" : ""
                    }
                  >
                    Discount - High to Low
                  </p>
                  <Form.Check
                    type="checkbox"
                    name="sortOptions"
                    value="DESC"
                    checked={selectedOption === "DESC"}
                    onChange={handleOptionChange}
                  />
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
        </Modal> */}
      </section>
    </>
  );
}

export default Sort_by_Modal;
